export function isOldTemplate(template: string, keys: string[] = []): boolean {
  const keyRegex = new RegExp(`{[\\s]*(${keys.join('|')}).*}`, 'g')
  return (
    (/[\s{(]options/.test(template) ||
      /[\s{(]if/.test(template) ||
      /[\s{(]foreach/.test(template) ||
      /[\s{(]each/.test(template) ||
      /[\s{(]image/.test(template) ||
      /\{\{@this\}\}/.test(template) ||
      /\{\{@key\}\}/.test(template) ||
      keyRegex.test(template)) &&
    !template.includes('@if(') &&
    !template.includes('@each(') &&
    !template.includes('@image(') &&
    !template.includes('@foreach(')
  )
}

export function parseLegacyTemplate(
  template: string,
  context: Record<string, unknown>,
): string {
  const contextKeys = Object.keys(context)
  if (!isOldTemplate(template, contextKeys)) {
    return template
  }

  let newTemplate = template
  newTemplate = newTemplate.replaceAll('image(', '@image(')
  newTemplate = newTemplate.replaceAll('formatDate(', '@formatDate(')
  newTemplate = newTemplate.replaceAll('if(', '@if(')
  newTemplate = newTemplate.replaceAll('options.', 'it.')

  contextKeys.forEach((key) => {
    const regexString = `.{2,3}${key}`
    const matches = newTemplate.match(new RegExp(regexString, 'g'))

    matches?.map((match) => {
      if (
        match.includes(`.`) ||
        match.includes('@') ||
        match.includes('?') ||
        !match.includes('{')
      ) {
        return
      }
      const newMatchString = match.replace(key, `it.${key}`)
      newTemplate = newTemplate.replaceAll(match, newMatchString)
    })
  })

  const hasForeachMatch = /foreach\(([\w.-]*)\)/.exec(newTemplate)
  const hasEachMatch = /each\(([\w.-]*)\)/.exec(newTemplate)

  // we need special replacement for these two loops
  if (hasForeachMatch) {
    const { input } = hasForeachMatch
    const innerLine = hasForeachMatch[1]
    const output = input
      .replace(`foreach(${innerLine})`, `@foreach(${innerLine}) => key, value`)
      .replaceAll('@this', 'value')
      .replaceAll('@key', 'key')
    newTemplate = newTemplate.replace(input, output)
  } else if (hasEachMatch) {
    const { input } = hasEachMatch
    const innerLine = hasEachMatch[1]
    const output = input
      .replace(`each(${innerLine})`, `@each(${innerLine}) => value, index`)
      .replaceAll('@this', 'value')
      .replaceAll('@index', 'index')

    newTemplate = newTemplate.replace(input, output)
  }

  newTemplate = newTemplate.replaceAll('options.', 'it.')
  newTemplate = newTemplate.replaceAll('it.it.', 'it.')
  newTemplate = newTemplate.replaceAll('it.it.it', 'it.')
  newTemplate = newTemplate.replaceAll('options.it', 'it.')
  newTemplate = newTemplate.replaceAll('@@image(', '@image(')
  newTemplate = newTemplate.replaceAll('@@formatDate(', '@formatDate(')
  newTemplate = newTemplate.replaceAll('@@foreach(', '@foreach(')
  newTemplate = newTemplate.replaceAll('@@each(', '@each(')

  return newTemplate
}
